import { AxiosError } from "axios";

const DELETED_USER_DETAIL = "user_id not found";

export const isDeletedUserError = (error: unknown): boolean => {
  if (!(error instanceof AxiosError) || !error.response) {
    return false;
  }

  const { status, data } = error.response;

  if (status === 401) {
    return true;
  }

  if (status === 400) {
    const detail = data?.detail ?? data?.message;
    return (
      typeof detail === "string" &&
      detail.toLowerCase() === DELETED_USER_DETAIL
    );
  }

  return false;
};

export const getAuthErrorMessage = (error: unknown): string | undefined => {
  if (!(error instanceof AxiosError) || !error.response) {
    return undefined;
  }

  const data = error.response.data as
    | { detail?: string; message?: string }
    | undefined;
  return data?.detail ?? data?.message;
};
